import * as React from 'react';
import { useState, createContext } from 'react';
import { Link, useNavigate } from "react-router-dom";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import AddIcon from "@mui/icons-material/Add";
import ContactsIcon from "@mui/icons-material/Contacts";
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import List from '@mui/material/List';

import AppNavigation from "router/AppNavigation";
import EditIcon from '@mui/icons-material/Edit';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SendIcon from '@mui/icons-material/Send';
import { useAsyncValue } from "react-router-dom";
import { CMAccountResponse, CurrentUserDetails } from "services/apiService";
import GroupIcon from '@mui/icons-material/Group';
import UnsubscribeIcon from '@mui/icons-material/Unsubscribe';
import AssessmentIcon from '@material-ui/icons/Assessment';
import RuleIcon from "@mui/icons-material/Rule";

export const MenuListItems = () => {
    const [open, setOpen] = useState(false);
    const [openAdds, setOpenAdds] = useState(false);
    const [cmAccounts, currentUserDetails] = useAsyncValue() as [
        CMAccountResponse,
        CurrentUserDetails
    ];

    console.log("currentUserDetails: ", currentUserDetails.is_superuser);

    const handleClick = () => {
        setOpen(!open);
    };

    const handleClickAdds = () => {
        setOpenAdds(!openAdds);
    };

    return (
        <>
            <ListItemButton onClick={handleClick}>
                <ListItemIcon>
                    <InboxIcon style={{ color: "#22E6C2" }} />
                </ListItemIcon>
                <ListItemText primary="Campaigns" />
                {open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>

            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    <ListItemButton
                        sx={{ pl: 4 }}
                        component={Link}
                        to={AppNavigation.DraftCampaigns}>
                        <ListItemIcon>
                            <EditIcon />
                        </ListItemIcon>
                        <ListItemText primary="Draft" />
                    </ListItemButton>
                    <ListItemButton
                        sx={{ pl: 4 }}
                        component={Link}
                        to={AppNavigation.ScheduledCampaigns}>
                        <ListItemIcon>
                            <AccessTimeIcon />
                        </ListItemIcon>
                        <ListItemText primary="Scheduled" />
                    </ListItemButton>
                    <ListItemButton
                        sx={{ pl: 4 }}
                        component={Link}
                        to={AppNavigation.SentCampaigns}>
                        <ListItemIcon>
                            <SendIcon />
                        </ListItemIcon>
                        <ListItemText primary="Sent" />
                    </ListItemButton>
                </List>
            </Collapse>

            <ListItemButton component={Link} to={AppNavigation.CreateCampaign}>
                <ListItemIcon>
                    <AddIcon color="secondary" />
                </ListItemIcon>
                <ListItemText primary="Create" />
            </ListItemButton>

            {/* {currentUserDetails.is_superuser &&  */}

            <ListItemButton onClick={handleClickAdds}>
                <ListItemIcon>
                    <ContactsIcon color="info" />
                </ListItemIcon>
                <ListItemText primary="Address Books" />
                {openAdds ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>

            <Collapse in={openAdds} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    <ListItemButton
                        sx={{ pl: 4 }}
                        component={Link}
                        to={AppNavigation.AddressBooks}>
                        <ListItemIcon>
                            <GroupIcon />
                        </ListItemIcon>
                        <ListItemText primary="Groups" />
                    </ListItemButton>
                    <ListItemButton
                        sx={{ pl: 4 }}
                        component={Link}
                        to={AppNavigation.Unsubscribers}>
                        <ListItemIcon>
                            <UnsubscribeIcon />
                        </ListItemIcon>
                        <ListItemText primary="Unsubs" />
                    </ListItemButton>
                </List>
            </Collapse>

            {/* } */}

            <ListItemButton component={Link} to={AppNavigation.DwhRequests}>
                <ListItemIcon>
                    <TrendingUpIcon color="warning" />
                </ListItemIcon>
                <ListItemText primary="DWH Requests" />
            </ListItemButton>

            <ListItemButton component={Link} to={AppNavigation.Reporting}>
                <ListItemIcon>
                    <AssessmentIcon color="primary" />
                </ListItemIcon>
                <ListItemText primary="Reporting" />
            </ListItemButton>

            <ListItemButton component={Link} to={AppNavigation.CheckNumberHLR}>
                <ListItemIcon>
                    <RuleIcon color="secondary" />
                </ListItemIcon>
                <ListItemText primary="Check number by HLR" />
            </ListItemButton>
        </>
    );
};